// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3YOat","fileBtn":"File_fileBtn__1S7eI","closeBtn":"File_closeBtn__1fUwZ","fileSelected":"File_fileSelected__3pcd0","disabled":"File_disabled__2hKQB"};